import { Briefcase, UserCheck, UserX, Link2, ClipboardCheck } from 'lucide-react'

type Props = {
  stats: {
    ativos: number
    inativos: number
    naoPreenchidos: number
    naoConcluidos: number
    total: number
  }
}

export function PjAgradaStatsCards({ stats }: Props) {
  const cards = [
    { label: 'Funcionários cadastrados', value: stats.total, icon: Briefcase, tone: 'text-[var(--brand-primary)]' },
    { label: 'Não preenchido', value: stats.naoPreenchidos, icon: Link2, tone: 'text-yellow-400' },
    { label: 'Não concluído', value: stats.naoConcluidos, icon: ClipboardCheck, tone: 'text-orange-500' },
    { label: 'Ativos', value: stats.ativos, icon: UserCheck, tone: 'text-emerald-500' },
    { label: 'Inativos', value: stats.inativos, icon: UserX, tone: 'text-amber-500' },
  ]

  return (
    <div className='grid grid-cols-1 gap-4 md:grid-cols-3 xl:grid-cols-5'>
      {cards.map((card) => (
        <div key={card.label} className='glass-card p-4 flex items-center gap-4'>
          <div className='w-10 h-10 rounded-lg bg-[var(--glass-bg)] flex items-center justify-center'>
            <card.icon size={18} className={card.tone} />
          </div>
          <div>
            <p className='text-[var(--font-color-muted)] text-xs uppercase tracking-wide'>{card.label}</p>
            <p className='text-2xl font-semibold text-[var(--font-color-h2)]'>{card.value}</p>
          </div>
        </div>
      ))}
    </div>
  )
}
